import React from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import {
  AnimatedModal,
  ModalContent,
  ModalHeader,
} from "../../modals/AnimatedModal";
import WhatsAppBotManagement from "./WhatsAppBotManagement";

/**
 * Delivery-center config modal that hosts the fiscal-note WhatsApp bot's
 * authorized-numbers manager. Only numbers registered here are read by the
 * bot — the front-door gate (evolution-webhook) and the OCR gate
 * (slapie-fiscal-rekognition-ocr) both enforce this allow-list.
 */
const FiscalBotNumbersModal = ({ show, closeModal }) => {
  return (
    <AnimatedModal isOpen={show} onClose={closeModal} width="90%" maxWidth="820px">
      <ModalHeader
        title="Bot de Notas WhatsApp"
        icon={WhatsAppIcon}
        onClose={closeModal}
      />
      <ModalContent>
        <WhatsAppBotManagement />
      </ModalContent>
    </AnimatedModal>
  );
};

export default FiscalBotNumbersModal;
